import BaseApp from "../BaseApp";
import TrayBarView from "./view/TrayBarView";
import TrayBarCollection from "./model/TrayBarCollection";
import TrayBarChannel from "./TrayBarChannel";
import ChatCounter from "./ChatCounter";


export default class TrayBarApp extends BaseApp {
    channel() {return TrayBarChannel;}
    channelEvents() {
        return {
            add: "onChannelAdd"
        };
    }

    async preload(params, callback) {
        this.collection = new TrayBarCollection();

        await this.initChat();
        this.initCalendar();

        callback();
    }

    onReady() {
        this.view = new TrayBarView({
            collection: this.collection
        });
        this.view.render();

        this.view.$el.appendTo($(document.body));
    }

    async initChat() {
        const chatCounter = new ChatCounter();
        await chatCounter.createTrayBarItem(this.collection);
    }

    initCalendar() {
        this.collection.add({
            sort: 2,
            icon: "calendar"
        });
        const calendarIcon = this.collection.find((trayModel) =>
            trayModel.get("icon") === "calendar"
        );

        calendarIcon.on("click", this.onClickCalendar.bind(this));
    }

    async onClickCalendar() {
        await system.requireNewModules(["@calendar"]);

        if ( this.calendar ) {
            this.calendar.show();
        } else {
            system.apps.run("calendar", (err, calendar) => {
                calendar.show();

                this.calendar = calendar;
                this.listenTo(this.calendar, "destroy", () => {
                    this.calendar = null;
                });
            });
        }
    }

    onChannelAdd(trayItem) {
        this.collection.add(trayItem);
    }
}